// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { Icon } from "semantic-ui-react";
import { jsx as _jsx } from "react/jsx-runtime";
export const IconClose = () => /*#__PURE__*/_jsx(Icon, {
  name: "close",
  link: true,
  "data-sentry-element": "Icon",
  "data-sentry-component": "IconClose",
  "data-sentry-source-file": "NotificationActionIcon.tsx"
});
export const IconDone = () => /*#__PURE__*/_jsx(Icon, {
  name: "check circle",
  link: true,
  "data-sentry-element": "Icon",
  "data-sentry-component": "IconDone",
  "data-sentry-source-file": "NotificationActionIcon.tsx"
});
export const IconExpand = () => /*#__PURE__*/_jsx(Icon, {
  name: "angle down",
  link: true,
  "data-sentry-element": "Icon",
  "data-sentry-component": "IconExpand",
  "data-sentry-source-file": "NotificationActionIcon.tsx"
});
export const IconReduce = () => /*#__PURE__*/_jsx(Icon, {
  name: "angle up",
  link: true,
  "data-sentry-element": "Icon",
  "data-sentry-component": "IconReduce",
  "data-sentry-source-file": "NotificationActionIcon.tsx"
});